export default __webpack_public_path__ + "assets/cleankitchen-mealkit/cleankitchen_mealkit_main.c4ab1f3b85dfb7bc082b5bdade60eed9.webp";